<template>
    <div>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#settlements" role="tab" aria-selected="false">
                                {{ $t('label.settlements') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#sent_files" role="tab" aria-selected="false">
                                {{ $t('settlement.sent_files') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#received_files" role="tab" aria-selected="false">
                                {{ $t('settlement.received_files') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
                <kt-panel-header-actions :style="headerAction">
                    <div :class="'btn btn-' + vpn_status.variant" data-toggle="dropdown">
                        {{ $t(vpn_status.status) }}
                    </div>
                    <ul class="dropdown-menu shadow-sm">
                        <li class="text-center">
                            <span>
                                <router-link to="/settlements/vpn-log">{{ $t('settlement.btn.show_vpn_logs') }}</router-link>
                            </span>
                        </li>
                    </ul>
                </kt-panel-header-actions>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div class="tab-pane active" id="settlements">
                        <manage-access-filter :action="filterAction" :exportExcel="exportToExcel"></manage-access-filter>
                        <div class="switch-div">
                            تسویه های دستی
                            <label class="switch m-0 mr-2 ml-2">
                                <input id="settlement_checkbox" type="checkbox" @change="checkbox_changed">
                                <span class="slider round"></span>
                            </label>
                            تمام تسویه ها
                        </div>
                        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                    </div>
                    <div class="tab-pane" id="sent_files">
                        <kt-row class="text-center">
                            <kt-col v-bind:key="index"
                                    v-for="(data, index) in files.sent"
                                    xs="12" md="3"
                            >
                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                </a>
                            </kt-col>
                        </kt-row>
                    </div>
                    <div class="tab-pane" id="received_files">
                        <div class="accordion accordion-toggle-arrow" id="accordion_one">
                            <div class="card">
                                <div class="card-header" id="headingOne">
                                    <h2 class="mb-0">
                                        <div class="card-title collapsed" data-toggle="collapse" data-target="#collapseOne" aria-controls="collapseOne">
                                            <i class="fa fa-file-alt" aria-hidden="true"></i>
                                            {{ $t('label.settlement_responses') }}
                                        </div>
                                    </h2>
                                </div>
                                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion_one">
                                    <div class="card-body">
                                        <kt-row class="text-center">
                                            <kt-col v-bind:key="index"
                                                    v-for="(data, index) in files.received"
                                                    xs="12" md="3"
                                            >
                                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion accordion-toggle-arrow" id="accordion_two">
                            <div class="card">
                                <div class="card-header" id="headingTwo">
                                    <h2 class="mb-0">
                                        <div class="card-title collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-controls="collapseTwo">
                                            <i class="fa fa-chart-bar" aria-hidden="true"></i>
                                            {{ $t('label.settlement_switch') }}
                                        </div>
                                    </h2>
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion_two">
                                    <div class="card-body">
                                        <kt-row class="text-center">
                                            <kt-col v-bind:key="index"
                                                    v-for="(data, index) in files.switch"
                                                    xs="12" md="3"
                                            >
                                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion accordion-toggle-arrow" id="accordion_three">
                            <div class="card">
                                <div class="card-header" id="headingThree">
                                    <h2 class="mb-0">
                                        <div class="card-title collapsed" data-toggle="collapse" data-target="#collapseThree" aria-controls="collapseThree">
                                            <i class="fa fa-credit-card"></i>
                                            {{ $t('label.settlement_announcement') }}
                                        </div>
                                    </h2>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion_three">
                                    <div class="card-body">
                                        <kt-row class="text-center">
                                            <kt-col v-bind:key="index"
                                                    v-for="(data, index) in files.announcement"
                                                    xs="12" md="3"
                                            >
                                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                                </a>
                                            </kt-col>
                                        </kt-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </div>
</template>

<script>
    import { ApiUrl, vpnService } from '@/common/api.service'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import manageAccessFilter from './manage-access-filter'
    import columns from "../datatable/columns";
    import actions from "../datatable/actions";
    import $ from 'jquery'
    import axios from "axios";
    import { KTApp } from '@/plugins/core/app'
    import toastr from "toastr";
    import {mapGetters} from "vuex";

    export default {
        components: {
            manageAccessFilter
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {},
                vpn_status: {
                    variant: '',
                    status: ''
                }
            }
        },
        computed: {
            ...mapGetters('settlement', [
                'files'
            ]),
            datatableProps() {
                return {
                    id: "settlement_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('settlement'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        saveState: {
                            cookie: false,
                        }
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actions
                }
            },
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },
        mounted() {
            this.$store.dispatch('settlement/fetchFiles')
            vpnService.fetch().then(response => {
                this.vpn_status.status = 'settlement.btn.' + response.data.data.status
                this.vpn_status.variant = response.data.data.variant
            })
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            exportToExcel(e, query){
                this.query = {
                    'query': query
                }

                let form = $('#settlement_export_form')
                let btn = $('#settlement_export_btn')
                form.validate({
                    rules: {
                        from_date: {
                            required: true,
                        },
                        to_date: {
                            required: true,
                        }
                    }
                })

                if(!form.valid()) {
                    return
                }

                KTApp.progress(btn)

                axios({
                    url: ApiUrl.path('settlement/settlements-excel-export'),
                    method: 'GET',
                    params: this.query,
                })
                    .then((response) => {
                        KTApp.unprogress(btn)
                        var fileLink = document.createElement('a');

                        fileLink.href = response.data.data;
                        fileLink.setAttribute('download', 'settlements.xlsx');
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    })
                    .catch(({response}) => {
                        KTApp.unprogress(btn)
                        this.toastr.error(response.data.message)
                    })
            },
            checkbox_changed(e) {
                let checkbox = $('#settlement_checkbox')

                if (checkbox.is(":checked"))
                    this.query.manual_settlements = 1
                else
                    this.query.manual_settlements = 0

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        }
    }
</script>

<style scoped>
    .switch-div {
        width: fit-content;
        padding: 8px 27px;
        background: #fff;
        box-shadow: 0 0 7px 0 #9c9c9c5e;
    }
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 20px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #6aad27;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 12px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    .slider.round {
        border-radius: 50px;
    }

    .slider.round:before {
        border-radius: 50px;
    }

    .info-icon {
        cursor: pointer;
        color: #0f9af0;
        display: inline-block;
    }
</style>